module.exports = __webpack_public_path__ + "static/media/racketLogo.9aefa69e.png";